import React, { useEffect, useRef } from 'react';
import FlexView from 'react-flexview/lib';
import { TweenMax } from 'gsap';

import McBLEACH from '../../assets/images/Menu/Weapons/McBLEACH.png';
import mchydrogenperoxide from '../../assets/images/Menu/Weapons/mcHydrogenPeroxide.png';
import McGas from '../../assets/images/Menu/Weapons/McGas.png';
import MCWASPSPRAY from '../../assets/images/Menu/Weapons/MCWASPSPRAY.png';

import * as d from './WeaponDescriptions';

export default function Weapons({ setClickedImg }) {
	let weaponPics = useRef();

	useEffect(() => {
		TweenMax.from(weaponPics, 2.2, {
			opacity: 0,
			x: 970,
			ease: 'elastic',
			delay: 0.7,
		});
	}, [weaponPics]);

	return (
		<FlexView column className="menuScroller" hAlignContent="center">
			<div className="menuTitle">Our Weapons</div>
			<FlexView
				margin="auto"
				className="menuScrollFlex"
				ref={(el) => (weaponPics = el)}
			>
				<div className="menuItem" onClick={() => setClickedImg(d.mcBleach)}>
					<img src={McBLEACH} alt="McBLEACH" />
				</div>
				<div
					className="menuItem"
					onClick={() => setClickedImg(d.mcHydrogenPeroxide)}
				>
					<img src={mchydrogenperoxide} alt="mchydrogenperoxide" />
				</div>
				<div className="menuItem" onClick={() => setClickedImg(d.mcWaspSpray)}>
					<img src={MCWASPSPRAY} alt="McGas" />
				</div>
				<div className="menuItem" onClick={() => setClickedImg(d.mcGas)}>
					<img src={McGas} alt="McGas" />
				</div>
			</FlexView>
		</FlexView>
	);
}
